export default "skymp5-front/e3daab301e11e5265237b08ad6cf4f29.jpg";